import WawMark from './brand/WawMark';

interface WasselLogoProps {
  size?: number;
  variant?: 'default' | 'inverted' | 'teal-bg';
}

/**
 * Legacy Wassel mark — now renders the waw monogram «و» (v1 brand identity).
 * The old animated radar-circle is retired (rejected as a brand symbol).
 * API preserved so existing call sites keep working:
 *  - default  → app-icon badge (green square + cream waw) — reads as a logo
 *               mark beside a wordname, not a loose letter
 *  - teal-bg  → same app-icon badge
 *  - inverted → cream waw glyph (for dark/green surfaces)
 */
export function WasselLogo({ size = 28, variant = 'default' }: WasselLogoProps) {
  if (variant === 'inverted') return <WawMark size={size} variant="cream" label="وصّل" />;
  return <WawMark size={size} boxed label="وصّل" />;
}

export default WasselLogo;
